module.exports = __webpack_public_path__ + "static/media/PRISM_8220.75b6415c.jpg";